/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * This setting defines inventory filtering options.
 */
export enum ProductListInventoryFilteringOptions {
    /**
     * Filter out all products out of stock.
     */
    HideOOS = 'hideOOS',

    /**
     * Sort products by availability, OOS goes last.
     */
    SortOOS = 'sortOOS',

    /**
     * No filtering selected.
     */
    Default = 'default'
}

/**
 * Get inventory sorting value based on channelInventoryConfiguration
 *
 * @param context The current action context
 * @param channelInventoryConfiguration The channelInventoryConfiguration
 */
export const getInventorySorting = channelInventoryConfiguration => {
    let sorting;
    if (channelInventoryConfiguration && channelInventoryConfiguration.ProductAvailabilitySortableAttributeRecordId) {
        const sortColumnName = `Attr_${channelInventoryConfiguration.ProductAvailabilitySortableAttributeRecordId}`;
        sorting = {
            Columns: [
                {
                    ColumnName: sortColumnName,
                    IsDescending: true
                }
            ]
        };
    }
    return sorting;
};

/**
 * Returns inventory in stock sortable refiner value.
 * @param  channelInventoryConfiguration - The channelInventoryConfiguration.
 * @returns Refiners.
 */
export const getInventoryInStockSortableRefinerValue = channelInventoryConfiguration => {
    if (channelInventoryConfiguration && channelInventoryConfiguration.ProductAvailabilitySortableAttributeRecordId) {
        return {
            RefinerRecordId: channelInventoryConfiguration.ProductAvailabilitySortableAttributeRecordId,
            DataTypeValue: 6,
            LeftValueBoundString: 'true',
            RightValueBoundString: 'true',
            UnitText: '',
            RowNumber: 0,
            Count: 0,
            ExtensionProperties: [],
            RefinerSourceValue: 1
        };
    }
    return undefined;
};
